export const examEvents = new EventTarget();

export const EXAM_UPDATE_EVENT = 'exam-updated';

export function triggerExamUpdate() {
  examEvents.dispatchEvent(new Event(EXAM_UPDATE_EVENT));
}

export const EXAM_NOTIFICATION_EVENT = 'exam-notification';

export type ExamNotificationKind = 'structure' | 'extraction' | 'message' | 'completed';

export interface ExamNotificationDetail {
  examId: string;
  conversationId: string;
  kind: ExamNotificationKind;
  message: string;
}

export function triggerExamNotification(detail: ExamNotificationDetail) {
  examEvents.dispatchEvent(new CustomEvent(EXAM_NOTIFICATION_EVENT, { detail }));
}
